export default class Move {
  constructor(id, actions) {
    this.id = id
    this._actions = actions
  }

  start() {
    return this._actions.find((v) => !!v.jumps).jumps[0]
  }

  end() {
    const moveActions = this._actions.filter((v) => !!v.jumps)

    const last = moveActions[moveActions.length - 1].jumps
    return last[last.length - 1]
  }

  fields() {
    return this._actions
      .filter((v) => !!v.jumps)
      .map((v) => v.jumps)
      .flat()
  }

  length() {
    return this.fields().length
  }

  actions() {
    return this._actions
  }
}
